import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 500px;
    flex-shrink: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        max-width: 100%;
    }
`;

export const InfoContainer = styled.div`
    background: white;
    border: 2px solid #aef001;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px;
        gap: 8px;
    }
`;

export const InfoItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    min-width: 0;
    width: 100%;

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: flex-start;
        padding-bottom: 12px;
        gap: 8px;

        &:last-child {
            padding-bottom: 0;
        }
    }
`;

export const InfoHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    font-size: 14px;

    img {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    b {
        font-size: 13px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        b {
            font-size: 14px;
        }
    }
`;

export const InfoValue = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        text-align: left;
        width: 100%;
        font-size: 15px;
    }
`;

export const ContractDetails = styled.div`
    width: 100%;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: flex-end;
    align-items: flex-end;

    .contract-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        min-width: 0;
        gap: 8px;

        span {
            color: #666;

            &.amount {
                font-weight: 600;
                color: #333;
                white-space: nowrap;
            }
        }

        @media (max-width: ${MOBILE_BREAKPOINT}) {
            font-size: 13px;
        }
    }

    .all-contracts-btn {
        margin-top: 8px;
        width: auto;
        max-width: 200px;
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background: transparent;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        padding: 4px 8px;
        cursor: pointer;
        color: #666;
        text-decoration: none;
        transition: all 0.3s;
        font-size: 10px;

        &:hover {
            border-color: #aef001;
            color: #000;
        }

        @media (max-width: ${MOBILE_BREAKPOINT}) {
            padding: 6px 10px;
            font-size: 11px;
            margin-top: 12px;
            max-width: 220px;
        }
    }
`;
